import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const CasePropTypes = PropTypes.shape({
    _id: PropTypes.string,
    caseCode: PropTypes.string,
    agentId: PropTypes.string,
    reportingManagerId: PropTypes.string,
    reportingManagerBackendId: PropTypes.string,
    customerId: PropTypes.string,
    companyId: PropTypes.string,
    productId: PropTypes.string,
    catalogueId: PropTypes.string,
    // agentCommissionId: PropTypes.string,
    companyCommissionPercentage: PropTypes.number,
    agentCommissionPercentage: PropTypes.number,
    stage: PropTypes.string,
    caseType: PropTypes.string,
    meta: PropTypes.shape({
        // vehicle insurance properties
        vehicleNumber: PropTypes.string,
    }),
    meta: PropTypes.shape({
        // car insurance properties
        vehicleProductId: PropTypes.string,
        policyDueDate: PropTypes.date,
        vehicleModelYear: PropTypes.string,
        vehicleNumber: PropTypes.string,
        mfgYear: PropTypes.date,
        engineNumber: PropTypes.string,
        chasisNumber: PropTypes.string,
        showroomDealerId: PropTypes.string,
        showroomDealer: PropTypes.string,
        tenure: PropTypes.string,
        loanAmount: PropTypes.string,
        disbursedAmount: PropTypes.string,
        firstEMI: PropTypes.string,
        EMIAmount: PropTypes.string,
        LastEMIDate: PropTypes.string,
    }),
});

export const CaseDefaultProps = {
    _id: undefined,
    caseCode: '',
    agentId: '',
    reportingManagerId: '',
    reportingManagerBackendId: '',
    customerId: '',
    companyId: '',
    productId: null,
    catalogueId:null,
    // agentCommissionId: '',
    companyCommissionPercentage: 0,
    agentCommissionPercentage: 0,
    stage: '',
    caseType: '',
    isPayout: false,
    // meta: {       
    //     vehicleNumber: '',
    // },
    meta: {
        // vehicle insurance properties
        vehicleProductId: '',
        policyDueDate: '',
        vehicleModelYear: '',
        vehicleNumber: '',
        mfgYear: PropTypes.date,
        engineNumber: '',
        chasisNumber: '',
        showroomDealerId: '',
        tenure: '',
        loanAmount: '',
        disbursedAmount: '',
        firstEMI: '',
        EMIAmount: '',
    }

};

export const CaseYupSchema = Yup.object().shape({
    agentId: Yup.string().required('Required'),
    reportingManagerId: Yup.string().required('Required'),
    // reportingManagerBackendId: Yup.string().required('Required'),
    customerId: Yup.string().required('Required'),
    companyId: Yup.string().required('Required'),
    productId: Yup.string().nullable(),
    catalogueId: Yup.string().nullable(),
    caseType: Yup.string().required('Required'),
    isPayout: Yup.boolean(),
    // .oneOf([true], 'isPayout must be true'),
    companyCommissionPercentage: Yup.number().required('Required').min(0, 'must be non-negative'),
    agentCommissionPercentage: Yup.number().required('Required').min(0, 'must be non-negative'),

});

export const VehicleQuotationDefaultProps = {
    vehicleIdvValue: 0,
    ratePercentage: 0,
    totalPolicyPremium: 0,
    odDiscountPercentage: 0,
    discountPassToCustomer: 0,
    odPremium: 0,
    rateValue: 0,
    loadingDiscountPercentage: 0,
    loadingDiscountValue: 0,
    nonElectAccIdVPercentage: 0,
    nonElectAccIdvValue: 0,
    nonElectAccIdvCharges: 0,
    cndIdvPercentage: 0,
    cndIdvValue: 0,
    cndIdvCharges: 0,
    electIdvPercentage: 0,
    electIdvValue: 0,
    electIdvCharges: 0,
    odPremiumValue: 0,
    vexValue: 0,
    insuranceValueAfterVex: 0,
    ncbPercentage: 0,
    ncbValue: 0,
    insuranceValueAfterNcb: 0,
    zeroDepreciationPercentage: 0,
    zeroDepreciationValue: 0,
    consumablePercentage: 0,
    consumableValue: 0,
    enginePercentage: 0,
    engineValue: 0,
    returnToInvoicePercentage: 0,
    returnToInvoiceValue: 0,
    goldPlanValue: 0,
    addonOdPremiumValue: 0,
    insuranceValueAfterAddonOd: 0,
    addonDiscountValue: 0,
    newOdPremiumValue: 0,
    thirdPartyValue: 0,
    ownerValue: 0,
    paidDriverValue: 0,
    passengerValue: 0,
    cngThirdPartyValue: 0,
    empLiabValue: 0,
    homeSecureValue: 0,
    comprehensiveValue: 0,
    gstTaxPercentage: 0,
    gstTaxValue: 0,
    insuranceValueWithGst: 0,
};

const VehicleQuotationDefaultProperties = {
    vehicleIdvValue: Yup.number().min(1, 'Please enter vehicle IDV').required('Required'),
    ratePercentage: Yup.number(),
    rateValue: Yup.number(),
    loadingDiscountPercentage: Yup.number(),
    loadingDiscountValue: Yup.number(),
    nonElectAccIdVPercentage: Yup.number(),
    nonElectAccIdvValue: Yup.number(),
    nonElectAccIdvCharges: Yup.number(),
    cndIdvPercentage: Yup.number(),
    cndIdvValue: Yup.number(),
    cndIdvCharges: Yup.number(),
    electIdvPercentage: Yup.number(),
    electIdvValue: Yup.number(),
    electIdvCharges: Yup.number(),
    odPremiumValue: Yup.number(),
    vexValue: Yup.number(),
    insuranceValueAfterVex: Yup.number(),
    ncbPercentage: Yup.number(),
    ncbValue: Yup.number(),
    insuranceValueAfterNcb: Yup.number(),
    zeroDepreciationPercentage: Yup.number(),
    zeroDepreciationValue: Yup.number(),
    consumablePercentage: Yup.number(),
    consumableValue: Yup.number(),
    enginePercentage: Yup.number(),
    engineValue: Yup.number(),
    returnToInvoicePercentage: Yup.number(),
    returnToInvoiceValue: Yup.number(),
    goldPlanValue: Yup.number(),
    addonOdPremiumValue: Yup.number(),
    insuranceValueAfterAddonOd: Yup.number(),
    addonDiscountValue: Yup.number(),
    newOdPremiumValue: Yup.number(),
    thirdPartyValue: Yup.number(),
    ownerValue: Yup.number(),
    paidDriverValue: Yup.number(),
    passengerValue: Yup.number(),
    cngThirdPartyValue: Yup.number(),
    empLiabValue: Yup.number(),
    homeSecureValue: Yup.number(),
    comprehensiveValue: Yup.number(),
    gstTaxPercentage: Yup.number(),
    gstTaxValue: Yup.number(),
    insuranceValueWithGst: Yup.number(),
};
export const VehicleQuotationDefaultSchema = Yup.object().shape({
    ...VehicleQuotationDefaultProperties,
});

export const VehicleCoverNoteDefaultProps = {
    cn_date: '',
    cn_number: '',
    self_cn_number: '',
    effective_date: '',
    expire_date: '',
    third_party_exp_date:'',
    policyType:'',

    ...VehicleQuotationDefaultProps,
};

export const VehicleCoverNoteDefaultSchema = Yup.object().shape({
    cn_date: Yup.date().required('Required'),
    cn_number: Yup.string().required('Required'),
    effective_date: Yup.date().required('Required'),
    third_party_exp_date: '',
    policyType: '',

    ...VehicleQuotationDefaultProperties,
});

export const VehicleInsurancePaymentDefaultProps = {
    payment_date: '',
    instrument_number: '',
    bank_name: '',
    amount: '',
    is_paid_by_us: false,
};

export const VehicleInsurancePaymentDefaultSchema = Yup.object().shape({
    payment_date: Yup.date().required('Required'),
    instrument_number: Yup.string().required('Required'),
    bank_name: Yup.string().required('Required'),
    amount: Yup.number().required('Required'),
});

export default {
    CaseDefaultProps,
    CasePropTypes,
    CaseYupSchema,
    VehicleQuotationDefaultProps,
    VehicleQuotationDefaultSchema,
    VehicleCoverNoteDefaultProps,
    VehicleCoverNoteDefaultSchema,
    VehicleInsurancePaymentDefaultProps,
    VehicleInsurancePaymentDefaultSchema,
};
